import { useState, useEffect } from "react";
import "./Verification.css";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import axios from "../../axios.jsx";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

export default function VerifyDetails() {
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [educationDetails, setEducationDetails] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState("");
  const loc = useLocation();
  const scholar = loc.state.mobile;
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != "VerifyOfficer") {
      alert("unauthorized to this page")
      logout();
    }
    const data = {
      mobile: scholar,
    };
    axios
      .post("/api/get-candidate-details", data)
      .then((resData) => {
        setCandidateDetails(resData.data);
        axios
          .post("api/get-education-details", data)
          .then((resData2) => {
            setEducationDetails(resData2.data);
          })
          .catch((e) => {
            alert("can't find scholar's education details");
          });
      })
      .catch((e) => {
        alert("can't find scholar's details");
      });
  }, []);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleApprove = () => {
    setLoading(true);
    const req = {
      mobile: scholar,
      status: "certified"
    }
    axios
      .put("api/update-verification-status", req)
      .then((resData => {
        alert("Approved Successfully");
        window.location.href = "/pending-verification-list"
      }))
      .catch((e) => {
        alert("server error try again")
        console.log(e);
      })
    setLoading(false);
  }
  const handleReject = () => {
    setLoading(true);
    const req = {
      mobile: scholar,
      status: "REJECTED",
      reason
    }
    axios
      .put("update-verification-status", req)
      .then((resData => {
        alert("Rejected Successfully");
        window.location.href = "/pending-verification-list"
      }))
      .catch((e) => {
        alert("server error try again")
        console.log(e);
      })
    setLoading(false);
  }
  return (
    <>
      <br />
      <br />
      <form className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Verify Scholar Details</h3>
          {candidateDetails === null || educationDetails === null ? (
            <center>
              <RotateLeftIcon
                sx={{
                  fontSize: "3rem",
                  margin: "0 auto",
                  color: "rgba(0,0,0,0.6)",
                  animation: "spin 1s linear infinite",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(360deg)",
                    },
                    "100%": {
                      transform: "rotate(0deg)",
                    },
                  },
                }}
              />{" "}
              Loading Details
            </center>
          ) : (
            <>
              <table>
                <tr>
                  <td>
                    <label>Scholar Name</label>
                  </td>
                  <td>
                    <input
                      value={candidateDetails.name}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Mobile</label>
                  </td>
                  <td>
                    <input
                      value={candidateDetails.mobile}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Mother Name</label>
                  </td>
                  <td>
                    <input
                      value={candidateDetails.mother_name}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Father Name</label>
                  </td>
                  <td>
                    <input
                      value={candidateDetails.father_name}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Social category</label>
                  </td>
                  <td>
                    <input
                      value={candidateDetails.social_category}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Date of Birth</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={candidateDetails.date_of_birth}
                      readOnly
                      type="date"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Photo</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + candidateDetails.photo} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Email Id</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={candidateDetails.email}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Permanent Address</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={candidateDetails.permanent_address}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Subject/Branch</label>
                  </td>
                  <td>
                    <input
                      value={educationDetails.subject}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>College/Instruction</label>
                  </td>
                  <td>
                    <input
                      value={educationDetails.name_of_college}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Faculty</label>
                  </td>
                  <td>
                    <input
                      value={educationDetails.faculty}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>M.A/M.Sc. M.Com./P.G</label>
                  </td>
                  <td>
                    <input
                      value={educationDetails.degree}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the University</label>
                  </td>
                  <td>
                    <input
                      value={educationDetails.name_of_university}
                      className="form-control"
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Month/Year of Passing</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={educationDetails.month_year_passing}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Name of the Supervisor</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={educationDetails.name_of_Supervisour}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Year of Admission into Ph.D Program</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={educationDetails.admission_year_of_phd}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Title of the Thesis</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={educationDetails.title_of_thesis}
                      readOnly
                      type="text"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Full time/Part time</label>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={educationDetails.time}
                      readOnly
                      style={{ marginRight: 10 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Submitting thesis within prescribed time?</label>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={educationDetails.thesis_on_time}
                      readOnly
                      style={{ marginRight: 10 }}
                    />

                  </td>
                </tr>
                {(educationDetails.thesis_on_time === "No") && (
                  <>
                    <tr>
                      <td>
                        <label>If No, have you taken time bar permission?</label>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={educationDetails.timebar_permission}
                          style={{ marginRight: 10 }}
                          readOnly
                        />
                      </td>
                    </tr>
                    {educationDetails.timebar_permission === "Yes" && (
                      <tr>
                        <td>
                          <label>if Yes,Attach the order</label>
                        </td>
                        <td>
                          <a href={axios.defaults.baseURL + "api" + educationDetails.phd_admission_order}
                            target="_blank"
                          >
                            <button type="button" className="btn btn-secondary">
                              View File
                            </button>
                          </a>
                        </td>
                      </tr>
                    )}
                  </>
                )}
                <tr>
                  <td>
                    <label>Date of Submission</label>
                  </td>
                  <td>
                    <input
                      className="form-control"
                      value={educationDetails.date_of_application}
                      readOnly
                      type="date"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Pre-PhD. Memo</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.prephd_memo}
                      target="_blank"
                    >
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>No Due Certificate</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.no_due}
                      target="_blank"
                    >
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>PhD Admission Order</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.phd_admission_order}
                      target="_blank"
                    >
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Suoervisor's Certificate</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.supervisours_certificate}
                      target="_blank"
                    >
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Joining report</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.joning_report} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Research Paper</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.research_paper} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Synopsis</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.synopsis} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Thesis</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.thesis} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-1</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.seminar1} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label>Seminar-2</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + educationDetails.seminar2} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                {/* <tr>
                                <td>
                                    <label>No Due Certificate</label>
                                </td>
                                <td>
                                    <a href="../images/kulogo.jpeg" target="_blank">
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                        >
                                            View File
                                        </button>
                                    </a>
                                </td>
                            </tr> */}
                <tr>
                  <td>
                    <label>Signature of Applicant</label>
                  </td>
                  <td>
                    <a href={axios.defaults.baseURL + "api" + candidateDetails.signature} target="_blank">
                      <button type="button" className="btn btn-secondary">
                        View File
                      </button>
                    </a>
                  </td>
                </tr>
                {/* <tr>
                                <td>
                                    <label>Date of Application</label>
                                </td>
                                <td>
                                    <input
                                        className="form-control"
                                        value={"dateOfApplication"}
                                        readOnly
                                        type="date"
                                    />
                                </td>
                            </tr> */}
              </table>
              <div className="d-grid gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary approve-btn"
                  onClick={handleApprove}
                  disabled={loading}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="btn btn-secondary reject-btn"
                  onClick={handleClickOpen}
                >
                  Reject
                </button>
              </div>
            </>
          )}
        </div>
      </form>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Resaon For Rejection</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Reason"
            type="text"
            fullWidth
            variant="standard"
            required
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleReject}>Reject</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/pvtOfficer-login";
}